/**
 * Generic execution of a persisted graphql query via GET request.
 *
 * @param id A generated operation id.
 * @param variables The operation variables, if it takes any.
 * @returns The result of the query as a promise
 */
import {
  AnyOperationId,
  OperationResult,
  OperationVariables,
} from '../../generated/operation-ids';

export async function get<T extends AnyOperationId>(
  id: T,
  variables?: OperationVariables<T>,
) {
  const url = new URL(process.env.GATSBY_GRAPHQL_ENDPOINT!);
  url.searchParams.append('queryId', id);
  if (variables) {
    url.searchParams.append('variables', JSON.stringify(variables));
  }
  const response = await fetch(url.toString(), {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  // A missing "persisted graphql requests" permission answers with a 403 that
  // carries no "errors", so the status has to be checked separately.
  if (!response.ok) {
    throw new Error(`Query "${id}" failed with status ${response.status}.`);
  }
  const { data, errors } = await response.json();
  if (errors) {
    throw new Error(errors[0].message);
  }
  return data as OperationResult<T>;
}
